import { Fragment, h } from "preact";
import { useSelector } from "react-redux";
import { useState } from "preact/hooks";

import { selectCurrentUserIsAdmin } from "../store";
import i18n from "../i18n";

import Button from "./Button.jsx";
import AddToProjectModal from "./AddToProjectModal.jsx";
import TalentAdminActions from "./TalentAdminActions.jsx";
import { createPortal } from "preact/compat";

export default function AddToProjectButton({ talent, onClick }) {
  const isAdmin = useSelector(selectCurrentUserIsAdmin);
  const [opened, setOpened] = useState(false);

  function handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!onClick || onClick()) setOpened(true);
  }

  return (
    <>
      {isAdmin ? (
        <TalentAdminActions
          class="hide-on-small"
          talent={talent}
          onClick={handleClick}
        />
      ) : (
        <Button text class="hide-on-small" onClick={handleClick}>
          {i18n.t("component.add_to_project_button.label")}
        </Button>
      )}
      {opened &&
        createPortal(
          <div class="nioomi-modal-wrapper">
            <AddToProjectModal
              talent={talent}
              admin={isAdmin}
              close={() => setOpened(false)}
              opened={opened}
            />
          </div>,
          document.getElementById("modals")
        )}
    </>
  );
}
